import React, { Component } from 'react';
import FloatInputComponent from './FloatInputComponent';

interface FloatInputContainerProps {
    changeAction: (e: any) => void;
    enterKeyAction?: (e) => void;
    value: string;
    autoFocus?: boolean;
    label?: string;
    isDarkMode?: boolean;
    placeHolder?: string;
    showErrors?: boolean;
    isValid?: boolean;
    invalidMessages?: string[] | undefined;
}

export default class FloatInputContainer extends Component<FloatInputContainerProps> {
    render() {
        return (
            <FloatInputComponent
                showErrors={this.props.showErrors}
                isValid={this.props.isValid}
                invalidMessages={this.props.invalidMessages}
                value={this.props.value}
                label={this.props.label || ''}
                changeAction={this.props.changeAction}
                enterKeyAction={this.props.enterKeyAction}
                isDarkMode={this.props.isDarkMode}
                placeHolder={this.props.placeHolder}
                autoFocus={this.props.autoFocus}
            />)
    }
}
